import * as React from 'react';
import { QueryResult, OperationVariables } from 'react-apollo';

import ACCOUNT_NAVIGATION_QUERY from 'user/queries/AccountNavigationQuery.gql';
import CurrentUser from 'auth/CurrentUser';
import Glyph from 'components/Glyph';
import Greeting from 'components/Greeting';
import Link from 'components/Link';
import Text from 'components/Text';
import UserAvatar from 'users/components/UserAvatar';
import UserNavigationMenu from 'components/UserNavigationMenu';
import { HoCQueryComponent } from 'types/typescript/util';

import { AccountNavigationQuery as AccountNavigationQueryData } from 'user/queries/__generated__/AccountNavigationQuery';

import './styles/AccountNavigation.scss';

type Props = {
  apolloProps: QueryResult<AccountNavigationQueryData>;
};

function AccountNavigation(props: Props) {
  const user = props.apolloProps.data?.user;
  const canAddProfilePicture = CurrentUser.getUser().canAddProfilePicture();
  const name = user ? user.display_name : '_ _ _';
  const isAdminOfPaidOrg = !!user?.organizations?.length;

  return (
    <div className="AccountNavigation">
      {canAddProfilePicture && user && (
        <Link to="/settings/profile">
          <UserAvatar className="AccountNavigation-avatar" user={user} color="white" size="large" />
        </Link>
      )}
      <div className="AccountNavigation-content">
        <Text color="thunder" size="xsmall">
          <Greeting />,
        </Text>
        <UserNavigationMenu showRCE={user?.is_rce ?? false} isAdminOfPaidOrg={isAdminOfPaidOrg}>
          <Link color="inherit" className="AccountNavigation-content-user">
            <Text truncate size="large">
              {name}
            </Text>
            <Glyph name="chevron-down" size="xsmall" />
          </Link>
        </UserNavigationMenu>
      </div>
    </div>
  );
}

const QueryComponent = HoCQueryComponent<AccountNavigationQueryData, OperationVariables, {}>(
  // function 1
  { query: ACCOUNT_NAVIGATION_QUERY }
);
const WrappedComponent = QueryComponent(AccountNavigation);
export { AccountNavigation };
export default WrappedComponent;
